module.exports = __webpack_public_path__ + "static/media/arrowUp.205a68b9.svg";